module.exports = __webpack_public_path__ + "static/media/ryan.4c450c46.png";